import { BulkResizeState } from "../../../types";

interface IPayload {
    payload: {
        value: number;
        imageId: string;
    };
}

export const setWidth = (state: BulkResizeState, { payload: { value, imageId } }: IPayload) => {
    const image = state.images.find((image) => image.id === imageId);
    if (!image) return;
    image.crop.width = value > 0 ? (value > image.original.width ? image.original.width : value) : 0;
};
